import { get } from '../../helpers/api';

export const ACCOUNTS_SERVICE_URI = '/accounts';
export const ACCOUNTS_BASE_URI = '/api/v1/transport-title';

export const getMobileTitlesByPhysicalId = async (physicalId) =>
  get(
    `${ACCOUNTS_SERVICE_URI}${ACCOUNTS_BASE_URI}/mobile/titles/${physicalId}`,
  );
